import { Classification, PageSection } from '@24i/nxg-sdk-photon';
import { BackstageAsset } from './guards';

export const determineAgeClassification = (asset: BackstageAsset): Classification | undefined => {
    if (typeof asset.ageClassification?.rating !== 'number') {
        if (typeof asset.ageClassification?.rating === 'string') {
            const ageRating = Number(asset.ageClassification?.rating);
            const isValidNumber = !Number.isNaN(ageRating);

            return isValidNumber
                ? { ...asset.ageClassification, rating: ageRating }
                : { ...asset.ageClassification, rating: null };
        }
        return { ...asset.ageClassification, rating: null };
    }
    return undefined;
};

export const formatPlaylistAssetKey = (v: PageSection): string =>
    JSON.stringify({ playlistId: v.playlistId, sorting: v.sorting, pinnedItems: v.pinnedItems });

export const formatComputedPlaylistAssetKey = (v: PageSection): string | undefined => {
    // eslint-disable-next-line no-underscore-dangle
    const params = v._links?.href?.split('playlists/');
    return params?.[1];
};

export const extractUniquePlaylistAssets = (
    data: PageSection[]
): { uniqPlaylistAssets: string[]; uniqComputedPlaylistAssets: string[] } => {
    const uniqPlaylistAssets = new Set<string>();
    const uniqComputedPlaylistAssets = new Set<string>();

    data.forEach((v) => {
        if (v.playlistId) {
            uniqPlaylistAssets.add(formatPlaylistAssetKey(v));
        }
        // eslint-disable-next-line no-underscore-dangle
        if (v.computedPlaylist && v?._links?.href) {
            const key = formatComputedPlaylistAssetKey(v);
            if (key) uniqComputedPlaylistAssets.add(key);
        }
    });

    return {
        uniqPlaylistAssets: Array.from(uniqPlaylistAssets),
        uniqComputedPlaylistAssets: Array.from(uniqComputedPlaylistAssets),
    };
};
